import { createContext } from 'react';
import type {
  GrowthProvider,
  OptimizerAction,
  GrowthMetrics,
} from '../types';

interface GrowthOpsContextType {
  // Data
  providers: GrowthProvider[];
  optimizerActions: OptimizerAction[];
  metrics: GrowthMetrics | null;

  // State
  loading: boolean;
  error: string | null;

  // Actions
  refreshProviders: () => Promise<void>;
  refreshOptimizerActions: (businessId?: string) => Promise<void>;
  refreshMetrics: () => Promise<void>;
  toggleGrowthAds: (businessId: string, enabled: boolean) => Promise<void>;
  togglePause: (businessId: string, paused: boolean) => Promise<void>;
}

export const GrowthOpsContext = createContext<GrowthOpsContextType | undefined>(
  undefined
);
